// Boshliq (2026-09-03, tog'a 952/961, tasdiq msg 973): USTAMA % sozlamasi.
// Zakupka + xarajat hisoblangach tovarning «Цена продажи» avtomat = tan narx × (1 + ustama/100).
// 0 — avto-ustama o'chiq. Qo'lda kiritilgan narxga avtomat hech qachon tegmaydi.
import { useMutation, useQuery } from "@tanstack/react-query"
import { Button, InputNumber, message, Space } from "antd"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { request } from "../../../../utils/config"

const GET_MARKUP = async () => (await request({ url: "Tenants/MarkupPercent", method: "GET" })).data
const SET_MARKUP = async (percent: number) =>
  (await request({ url: "Tenants/SetMarkupPercent", method: "POST", params: { percent } })).data

export default function MarkupPercent() {
  const { t } = useTranslation()
  const [value, setValue] = useState<number>(0)

  const { data, refetch, isLoading } = useQuery(["GET_MARKUP_PERCENT"], GET_MARKUP, { staleTime: 60000 })
  useEffect(() => {
    if (data?.markupPercent !== undefined && data?.markupPercent !== null) setValue(Number(data.markupPercent) || 0)
  }, [data])

  const { mutate: save, isLoading: saving } = useMutation(SET_MARKUP, {
    onSuccess: (d: any) => {
      // Boshliq (2026-09-03): nechta narxsiz tovarga darhol qo'llangani ko'rsatiladi
      const n = Number(d?.applied) || 0
      message.success(n > 0 ? `${t("markupSaved")} — ${t("markupApplied")}: ${n}` : t("markupSaved"))
      refetch()
    },
    onError: (e: any) => message.error(e?.response?.data?.message || t("error")),
  })

  const example = Math.round(10 * (1 + (Number(value) || 0) / 100) * 100) / 100
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <Space wrap>
        <span>{t("markupPercent")}:</span>
        <InputNumber
          min={0} max={1000} step={1} precision={2}
          value={value}
          disabled={isLoading}
          onChange={(v) => setValue(Number(v) || 0)}
          style={{ width: 140 }}
          formatter={(v) => `${v ?? ""}`}
        />
        <span>%</span>
        <Button type="primary" loading={saving} disabled={isLoading} onClick={() => save(Number(value) || 0)}>
          {t("save")}
        </Button>
      </Space>
      <div style={{ fontSize: 12, color: "var(--gp-muted, #64748b)" }}>{t("markupHint")}</div>
      {Number(value) > 0 && (
        <div style={{ fontSize: 12, color: "var(--gp-muted, #64748b)" }}>
          {t("markupExample")} {Number(value)}% → <b>${example}</b>
        </div>
      )}
    </div>
  )
}
